import React from 'react';
import PropTypes from 'prop-types';

const Tab = props => (
    <div className="sales__catalogueRefineOptions">
        {props.children}
    </div>
);

Tab.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.arrayOf(PropTypes.node)
    ]).isRequired,
};

export default Tab;



// WEBPACK FOOTER //
// ./src/js/components/Catalogue/Tab.js